import MiniHeroSection from "../components/MiniHeroSection";
import ContactusSection from "../components/ContactusSection";
import ContentBelowHeroBanner from "../components/ContentBelowHeroBanner";
import ScaleableSection from "../components/ScaleableSection";
import WhatWeStandForSection from "../components/WhatWeStandForSection";
import CounterSection from "../components/CounterSection";
import PopupSection from "../components/PopupSection";
import useSWR from "swr";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { secureFetcher, SECURITY_CONFIG } from "../config/security";
import AIReadySection from "../components/about/AIReadySection";

function AboutUs() {
  const [popup, setPopup] = useState(false);

  const OpenPopup = (x) => {
    setPopup(x);
  };

  const {
    data: AboutData,
    error,
    isLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/148`,
    secureFetcher,
  );
  const {
    data: AboutPageData,
    error: AboutPageDataError,
    isLoading: AboutPageDataLoading,
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/pages/148",
    secureFetcher,
  );

  return (
    <>
      {AboutPageData && (
        <Helmet>
          <title>{AboutPageData.yoast_head_json?.title}</title>
          <meta
            property="og:title"
            content={AboutPageData.yoast_head_json?.og_title}
          />
          <meta
            property="og:description"
            content={AboutPageData.yoast_head_json?.og_description}
          />
        </Helmet>
      )}
      <MiniHeroSection data={AboutData?.acf?.hero_banner} />
      <ContentBelowHeroBanner
        data={AboutData?.acf?.content_below_hero_banner}
      />
      <CounterSection data={AboutPageData?.acf?.counter_section} />
      <WhatWeStandForSection
        data={AboutPageData?.acf?.what_we_stand_section}
        popup={(x) => OpenPopup(x)}
      />
      <ContactusSection data={AboutPageData?.acf?.our_data_center_section} />
      <AIReadySection content={AboutPageData?.acf?.ai_ready_section} />
      {/* <ScaleableSection data={AboutPageData?.acf?.ai_ready_section} /> */}

      {popup && <PopupSection popup={(x) => OpenPopup(x)} />}
    </>
  );
}
export default AboutUs;
